import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\ExportCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/ExportCommissionNoteListController.php
* @route '/api/commission-note-dashboard/export'
*/
const ExportCommissionNoteListController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExportCommissionNoteListController.url(options),
    method: 'post',
})

ExportCommissionNoteListController.definition = {
    methods: ["post"],
    url: '/api/commission-note-dashboard/export',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\ExportCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/ExportCommissionNoteListController.php
* @route '/api/commission-note-dashboard/export'
*/
ExportCommissionNoteListController.url = (options?: RouteQueryOptions) => {
    return ExportCommissionNoteListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\ExportCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/ExportCommissionNoteListController.php
* @route '/api/commission-note-dashboard/export'
*/
ExportCommissionNoteListController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExportCommissionNoteListController.url(options),
    method: 'post',
})

export default ExportCommissionNoteListController